// src/context/ToastContext.js
import React, { createContext, useState, useContext, useCallback } from 'react'; // 1. Import useCallback
import Toast from '../components/common/Toast';

const ToastContext = createContext();

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [toastConfig, setToastConfig] = useState({
    show: false,
    message: '',
    type: 'info',
    duration: 5000,
  });

  // 2. Wrap showToast in useCallback
  const showToast = useCallback((message, type = 'info', duration = 5000) => {
    setToastConfig({ show: true, message, type, duration });
  }, []); // <-- Empty dependency array ensures this function is created only ONCE

  // 3. Wrap hideToast in useCallback
  const hideToast = useCallback(() => {
    setToastConfig((prev) => ({ ...prev, show: false }));
  }, []); // <-- Empty dependency array for the same reason

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast show={toastConfig.show} message={toastConfig.message} type={toastConfig.type} duration={toastConfig.duration} onClose={hideToast} />
    </ToastContext.Provider>
  );
};
